import {
  Button,
  Checkbox,
  Form,
  Input,
  Select,
  Spin,
  Switch,
  message,
  notification,
} from "antd";
import { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import axios from "../../../config/axiosInstance";
import { useSelector } from "react-redux";
import moment from "moment";
import { API } from "../../../config/API";
import {
  uploadImageToS3,
  uploadImageToS3banner,
} from "../../../config/s3config/s3fileUpload";
import { BsUpload } from "react-icons/bs";
import ImageUpload from "../../../assets/image/Group 225.svg";
import PageHeader from "../../../component/pageHeaders/index";
import { useLocation, useNavigate } from "react-router-dom";
import { LoadCategories, LoadTags } from "../../../utils/commonapis";
import ImagePicker2 from "../../../component/image-pickersecond";

function NewForm() {
  const location = useLocation();
  const props = location?.state?.items;

  const navigate = useNavigate();

  const User = useSelector((state: any) => state.User.user);

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [imageurl, setImageurl] = useState<any>(props?.banner_image || "");
  const [categories, setCategories] = useState([]);

  const [isLoading, setIsLoading] = useState<any>(false);
  const [isUploading, setIsUploading] = useState<any>(false);
  const [imageUploader, setImageUploader] = useState<any>(false);
  const [tags, setTags] = useState([]);

  const [reelsId, setReelsId] = useState() as any;
  const [tagFilter, setTagFilters] = useState("");
  const [loading3, setLoading3] = useState(true);

  useEffect(() => {
    loadCategories();
  }, []);

  useEffect(() => {
    loadTags(tagFilter);
  }, [tagFilter]);

  const loadTags = async (searchTerm: any) => {
    setLoading3(true);
    try {
      const res: any = await LoadTags(searchTerm);
      setTags(res);
    } catch (error) {
    } finally {
      setLoading3(false);
    }
  };
  function debounce(func: any, delay: any) {
    let timer: any;
    return (...args: any) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  }

  const OnTagSearch = debounce((value: any) => {
    setTagFilters(value);
  }, 200);

  const loadCategories = async () => {
    const res: any = await LoadCategories();
    setCategories(res.data);
    if (props?.categories && res.data?.length > 0 && props.categories.length === res.data.length) {
      form.setFieldsValue({ selectall: true });
    }
  };

  const formItemLayout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
  };

  const onFinish = (values: any) => {
    let categori;
    if (values.selectall === true) {
      categori = categories.map((item: any) => ({
        id: item.id,
        category: item.attributes.category,
      }));
    } else {
      categori = values?.categories
        ? values.categories.map((item: any) => JSON.parse(item))
        : null;
    }

    const tags = values.tags
      ? values.tags?.map((item: any) => JSON.parse(item))
      : null;

    setIsLoading(true);
    let requestObj = {
      data: {
        banner_image: imageurl,
        type: values.type ? values.type : "",
        hyperlink: values.hyperlink ? values.hyperlink : "",
        handleShow: values?.Show || false,
        categories: categori,
        permalink: values?.permalink,
        tags: tags !== null ? tags.map((item: any) => item.id) : null,
        publishedAt: props?.id ? props?.publishedAt : null,
      },
    };
    let url = props?.id
      ? API.BASE_URL + API.BANNERS + `/${props?.id}`
      : API.BASE_URL + API.BANNERS;
    let method = props?.id ? "PUT" : "POST";

    const request = props?.id ? axios.put(url, requestObj) : axios.post(url, requestObj);
    return request
      .then((response) => {
        setIsLoading(false);
        notification.success({ message: `success` });
        setReelsId(response.data?.data?.id);
        if (props?.id) {
          navigate(`/Auth/banner`);
        }
        return response.data;
      })
      .catch((error) => {
        setIsLoading(false);
        notification.error({ message: error?.message || "Failed to save banner" });
        throw error;
      });
  };

  const onPublish = (id: any) => {
    setLoading(true);
    try {
      let url = API.BASE_URL + API.BANNERS + `/${id}`;
      let requestObj = {
        data: {
          publishedAt: new Date(),
        },
      };
      axios({
        method: "PUT",
        url: url,
        data: requestObj,
      })
        .then((response) => {
          console.log(response);
          message.success("Published");
          navigate(`/Auth/banner`);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
        });
    } catch (error) {
      setLoading(false);
      console.log("======error=====", error);
    }
  };

  const onImageUpload = async (value: any) => {
    setIsUploading(true);
    const response: any = await uploadImageToS3banner(value);
    if (response) {
      setImageurl(response?.data?.imageUrl);
      setIsUploading(false);
    }
  };

  const addImageToList = async (val: any) => {
    if (val?.type === "medialibrary") {
      setImageurl(val?.val);
    } else {
      await onImageUpload(val?.val?.file);
    }
  };

  return (
    <div style={{ maxHeight: "100vh", overflow: "scroll" }}>
      <PageHeader
        title={`${
          props?.id !== null && props?.id !== undefined ? "Edit" : "Create"
        } Banner`}
      ></PageHeader>
      <div className="banner-form-wrapper" style={{ padding: "10px 20px" }}>
        <Form
          {...formItemLayout}
          initialValues={{
            type: props?.type,
            categories:
              props?.categories &&
              props?.categories?.map((item: any) => {
                let obj = {
                  id: item?.id,
                  category: item?.category,
                };
                return JSON.stringify(obj);
              }),
            tags:
              props?.tags &&
              props?.tags?.map((item: any) => {
                let obj = {
                  id: item?.id,
                  tag: item?.tag,
                };
                return JSON.stringify(obj);
              }),
            permalink: props?.permalink,
            hyperlink: props?.hyperlink,
            Show: props?.handleShow || false,
          }}
          onFinish={onFinish}
          form={form}
        >
          <Row>
            <Col md={6}>
              <Row>
                <label className="reelScrn-formLabel">Position</label>
                <Form.Item name="type">
                  <Select placeholder="Select Role" size="large">
                    <Select.Option value={"Home"}>Home-Header</Select.Option>
                    <Select.Option value={"Editorial"}>
                      Above-Editorial
                    </Select.Option>
                    <Select.Option value={"Shortz"}>Above-Shortz</Select.Option>
                    <Select.Option value={"detailedNews"}>
                      Above-detailedNews
                    </Select.Option>
                  </Select>
                </Form.Item>
              </Row>
              <Row>
                <Form.Item name="selectall" valuePropName="checked">
                  <Checkbox>Select all From Categories</Checkbox>
                </Form.Item>
                <label className="newsFormLabels">Categories</label>
                <Form.Item name="categories">
                  <Select mode="tags" size="large">
                    {categories.length > 0 &&
                      categories.map((item: any, index: any) => {
                        let obj = {
                          id: item.id,
                          category: item.attributes.category,
                        };
                        let category = JSON.stringify(obj);
                        return (
                          <Select.Option key={index} value={category}>
                            {item?.attributes?.category}
                          </Select.Option>
                        );
                      })}
                  </Select>
                </Form.Item>
              </Row>
              <Row>
                <label className="newsFormLabels">Tags</label>
                <Form.Item name="tags">
                  <Select
                    style={{ background: "transparent" }}
                    mode="multiple"
                    size="large"
                    loading={loading3}
                    onSearch={(val) => OnTagSearch(val)}
                  >
                    {tags.length &&
                      tags.map((item: any, index: any) => {
                        let obj = {
                          id: item.id,
                          tag: item.tag,
                        };
                        let tags = JSON.stringify(obj);
                        return (
                          <Select.Option key={index} value={tags}>
                            {item.tag}
                          </Select.Option>
                        );
                      })}
                  </Select>
                </Form.Item>
              </Row>
              <Row>
                <label className="reelScrn-formLabel">allow T0 Live </label>
                <Form.Item name="Show" valuePropName="checked">
                  <Switch />
                </Form.Item>
              </Row>
            </Col>
            <Col md={6}>
              <Row>
                <label className="reelScrn-formLabel">Hyper-Link</label>
                <Form.Item name="hyperlink">
                  <Input size="large" />
                </Form.Item>
              </Row>
              <Row>
                <label className="reelScrn-formLabel">Perma Link</label>
                <Form.Item name="permalink">
                  <Input size="large" />
                </Form.Item>
              </Row>
              <Row>
                <label className="reelScrn-formLabel">
                  Upload banner-image (1116 × 100 px)
                </label>
                <Form.Item name="image" {...formItemLayout}>
                  {isUploading ? (
                    <div
                      style={{
                        height: "150px",
                        backgroundColor: "#f1f1f1",
                        borderRadius: 8,
                        border: "1px dashed #ccc",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                        gap: 10,
                      }}
                    >
                      <Spin />
                      <div style={{ color: "#888", fontSize: 14 }}>Uploading...</div>
                    </div>
                  ) : imageurl ? (
                    <div
                      style={{
                        borderRadius: 8,
                        border: "1px solid #e1e5e9",
                        overflow: "hidden",
                        background: "#fff",
                      }}
                    >
                      <img
                        src={imageurl}
                        style={{
                          width: "100%",
                          objectFit: "contain",
                          display: "block",
                        }}
                      />
                      <div
                        style={{
                          display: "flex",
                          gap: 10,
                          padding: "8px 12px",
                          borderTop: "1px solid #e1e5e9",
                        }}
                      >
                        <Button
                          size="small"
                          type="primary"
                          onClick={() => setImageUploader(true)}
                        >
                          Change
                        </Button>
                        <Button
                          size="small"
                          danger
                          onClick={() => setImageurl("")}
                        >
                          Remove
                        </Button>
                      </div>
                    </div>
                  ) : (
                    <div
                      className="imageuploadbox"
                      style={{
                        height: "150px",
                        backgroundColor: "#f1f1f1",
                      }}
                      onClick={() => setImageUploader(true)}
                    >
                      <img
                        style={{ width: "50%", height: 50 }}
                        src={ImageUpload}
                      />
                      <div className="reelScrn-Uploadtxt">
                        Upload banner-image
                      </div>
                    </div>
                  )}
                </Form.Item>
              </Row>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col md={6} />
            <Col md={6}>
              <div style={{ display: "flex", gap: 10 }}>
                <Button
                  block
                  style={{ height: 50 }}
                  htmlType="submit"
                  loading={isLoading}
                >
                  {props?.id ? "Update" : "Save"}
                </Button>
                <Button
                  disabled={props?.publishedAt ? true : false}
                  block
                  type="primary"
                  style={{ height: 50 }}
                  loading={loading}
                  onClick={() => onPublish(props?.id || reelsId)}
                >
                  Publish
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
      <br />
      {imageUploader ? (
        <ImagePicker2
          onSubmit={(val: any) => addImageToList(val)}
          visible={imageUploader}
          close={() => setImageUploader(false)}
        />
      ) : null}
    </div>
  );
}

export default NewForm;
